export const EMAIL_CHANGE_CLEAR = 'EMAIL_CHANGE_CLEAR';
export const EMAIL_CHANGE_START = 'EMAIL_CHANGE_START';
export const EMAIL_CHANGE_FINISH = 'EMAIL_CHANGE_FINISH';
export const EMAIL_CHANGE_UPDATE_EMAIL = 'EMAIL_CHANGE_UPDATE_EMAIL';
export const EMAIL_CHANGE_CLEAR_ERROR = 'EMAIL_CHANGE_CLEAR_ERROR';
